import { Command } from "@/app/common/base/command"

export class NpsSubmitFreeAnswerCommand extends Command {
    public async run(resultId: string, freeAnswer: string){
        await this.client.post('/api/nps-feedback/free-answer', { resultId, freeAnswer })
    }
}
